import { REGEX_ADDRESS_FORBIDDEN_SYMBOLS } from 'clickNgo/configs/regex'

const MIN_LENGTH = 3
const MAX_LENGTH = 120

export const checkAddress = (value: string) => {
  if (value.length < 3 || value.length > 120 || REGEX_ADDRESS_FORBIDDEN_SYMBOLS.test(value)) {
    return `The field AddressLine1 has an incorrect value.
        Enter at least ${MIN_LENGTH} and must less than ${MAX_LENGTH} characters.
        Don't use the following: ${REGEX_ADDRESS_FORBIDDEN_SYMBOLS.source}`
  }
  return ''
}
